import { useEffect, useState } from "react";

export const useViewportDevice = () => {

  const [device, setDevice] = useState({});

  const detect = () => {

    const orientation = window.screen.orientation?.type;
    const isPortrait  = orientation?.startsWith("portrait");
    const isLandscape = orientation?.startsWith("landscape");

    setDevice({
      isMobilePortrait  : window.innerWidth >= 320  && window.innerWidth <= 440  && isPortrait ,
      isMobileLandscape : window.innerWidth >= 568  && window.innerWidth <= 926  && isLandscape,
      isTabletPortrait  : window.innerWidth >= 768  && window.innerWidth <= 1024 && isPortrait ,
      isTabletLandscape : window.innerWidth >= 1024 && window.innerWidth <= 1194 && isLandscape,
      isDesktop         : window.innerWidth >= 1280
    });

  };

  useEffect(() => {

    detect();
    window.addEventListener("resize", detect);
    window.addEventListener("orientationchange", detect);

    return () => {
      window.removeEventListener("resize", detect);
      window.removeEventListener("orientationchange", detect);
    };

  }, []);

  return device;
  
};
